import { 
  LayoutDashboard, 
  Users, 
  FileCheck, 
  CreditCard,
  Database,
  Link2,
  ShieldCheck,
  UserPlus,
  MessageSquare,

  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useState } from 'react';

const navItems = [
  { title: 'Dashboard', url: '/admin', icon: LayoutDashboard },
  { title: 'Companies', url: '/admin/companies', icon: CreditCard },
  { title: 'Users', url: '/admin/users', icon: Users },
  { title: 'Signups', url: '/admin/signups', icon: UserPlus },
  { title: 'Verification', url: '/admin/verification', icon: ShieldCheck },
  { title: 'FMCSA Requests', url: '/admin/fmcsa-requests', icon: FileCheck },
  { title: 'Affiliates', url: '/admin/affiliates', icon: Link2 },
  { title: 'LR Hub Moderation', url: '/admin/hub-moderation', icon: MessageSquare },
  { title: 'Import Cities', url: '/admin/import-cities', icon: Database },

];

export function AdminSidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <aside className={cn(
      "h-screen bg-[#0d1117] border-r border-[#1e2530] flex flex-col transition-all duration-300",
      collapsed ? "w-16" : "w-60"
    )}>
      {/* Header */}
      <div className="h-14 flex items-center justify-between px-4 border-b border-[#1e2530]">
        {!collapsed && (
          <span className="text-sm font-semibold text-white">Admin Panel</span>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-1.5 rounded-md hover:bg-[#1e2530] text-[#6b7280] hover:text-white transition-colors"
        >
          {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-2 space-y-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.url || 
            (item.url !== '/admin' && location.pathname.startsWith(item.url));
          
          return (
            <NavLink
              key={item.url}
              to={item.url}
              className={cn(
                "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors",
                isActive 
                  ? "bg-[#14b8a6]/10 text-[#14b8a6]" 
                  : "text-[#9ca3af] hover:text-white hover:bg-[#1e2530]"
              )}
            >
              <item.icon className="w-4 h-4 flex-shrink-0" />
              {!collapsed && <span>{item.title}</span>}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-2 border-t border-[#1e2530]">
        <NavLink
          to="/broker-dashboard"
          className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-[#9ca3af] hover:text-white hover:bg-[#1e2530] transition-colors"
        >
          <ChevronLeft className="w-4 h-4 flex-shrink-0" />
          {!collapsed && <span>Back to App</span>}
        </NavLink>
      </div>
    </aside>
  );
}
